import { render, staticRenderFns } from "./AuditNoteHeader.vue?vue&type=template&id=0f0b85b3&scoped=true&"
import script from "./AuditNoteHeader.vue?vue&type=script&lang=js&"
export * from "./AuditNoteHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuditNoteHeader.vue?vue&type=style&index=0&id=0f0b85b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b85b3",
  null
  
)

export default component.exports